var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManUsingLaptop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f5f7f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.607,
    y1: 0.993,
    x2: 0.357,
    y2: 0.043,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f1844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3d3c99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.037,
    y1: 0.568,
    x2: 0.94,
    y2: 0.428,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bbc0d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6dbf8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.981,
    y1: 0.964,
    x2: 0.029,
    y2: 0.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1.017,
    y1: 0.864,
    x2: 0.071,
    y2: 0.195,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.041,
    y1: 0.92,
    x2: 0.969,
    y2: 0.065,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.036,
    y1: 0.881,
    x2: 0.983,
    y2: 0.089,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1.001,
    y1: 0.684,
    x2: -0.005,
    y2: 0.309,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.062,
    y1: 0.87,
    x2: 0.996,
    y2: 0.07,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.785,
    y1: 0.026,
    x2: 0.218,
    y2: 0.971,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3d3c99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.27,
    y1: 0.73,
    x2: 0.552,
    y2: 0.45,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e4eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f3f6fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.408,
    y1: 1.049,
    x2: 0.514,
    y2: 0.379,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -0.037,
    y1: 0.266,
    x2: 0.197,
    y2: 0.605,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -0.064,
    y1: 0.926,
    x2: 0.81,
    y2: 0.051,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.27,
    y1: 1.15,
    x2: 0.47,
    y2: 1.756,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.667,
    y1: 1.95,
    x2: 0.68,
    y2: 1.004,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -0.031,
    y1: 0.82,
    x2: 0.767,
    y2: 0.001,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.729,
    y1: 1.273,
    x2: 0.897,
    y2: 1.904,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.785,
    y1: 0.026,
    x2: 0.218,
    y2: 0.971,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6eaf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f3f6fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.104,
    y1: 0.57,
    x2: 0.955,
    y2: 0.346,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#8988d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9d9ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a5ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bbbfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6dbf8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -0.003,
    x2: 0.997,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.819,
    y1: 0.93,
    x2: 0.391,
    y2: 0.112,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd0b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#facab2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d7a384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#be8662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#af744d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a96e46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 0.5,
    y1: 0.989,
    x2: 0.5,
    y2: 0.004,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#201f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3d3c99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403da0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 0.752,
    y1: 0.512,
    x2: 1.016,
    y2: 0.521,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#343381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3d3c99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403da0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 0.212,
    y1: 0.965,
    x2: 0.689,
    y2: 0.103,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0.642,
    y1: 0.5,
    x2: 1.781,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a5ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#9d9ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8988d5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1.963,
    y1: -0.042,
    x2: 5.009,
    y2: -1.044,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a96e46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#af744d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#be8662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d7a384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#facab2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd0b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -0.244,
    y1: 0.5,
    x2: 1.069,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bbbfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#cacde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#f2f3f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -0.023,
    y1: 0.707,
    x2: 1.261,
    y2: 0.235,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0.352,
    y1: 0.767,
    x2: 0.906,
    y2: 0.131,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd0b9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a96e46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -0.001,
    y1: 0.5,
    x2: 1.001,
    y2: 0.5,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0.5,
    y1: 0.921,
    x2: 0.5,
    y2: 0.02,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 0.135,
    y1: 0.857,
    x2: 0.719,
    y2: 0.291,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f2f3f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#cacde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bbbfd9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1.004,
    y1: 0.166,
    x2: 0.111,
    y2: 0.99,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a96e46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd0b9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 0.54,
    y1: 0.693,
    x2: 1.186,
    y2: -0.27,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 0,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_12-Black_Man_Using_Laptop"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_12-Black_Man_Using_Laptop",
    "data-name": "12-Black Man_Using Laptop",
    clipPath: "url(#clip-_12-Black_Man_Using_Laptop)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Black_Businessman-12",
    "data-name": "Black Businessman-12",
    transform: "translate(0 38.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M481.794,221.044C437.988,131.5,312.7.343,149.9,0-19.974-.35-36.407,168.137,55.154,214.969s-42.3,105.2,53.4,163.854c96.871,59.363,303.885,53.79,354.841,7.611S500.719,259.738,481.794,221.044Z",
    transform: "translate(0.579 0.294)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M47.746,156.026s21.5-23.933,19.228-33.368S78.033,101.766,78.3,88.024c.295-15.565-8.025-11.4-10.9-18.057-4.26-9.865,5.231-18.6-9.124-22.373-9.8-2.58-16.72,2.452-15.8-9.674S38.98,10.787,31.122,5.333C19.9-2.445-2.915-3.058,4.769,12.634c8.081,16.481.963,43.639-.924,51.075C-16.052,142.292,47.746,156.026,47.746,156.026Z",
    transform: "translate(21.752 181.705)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M0,0C2.468,20.295,27.906,52.707,16.377,74.379s5.947,55.215,5.947,55.215",
    transform: "translate(45.51 203.209)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M53.608,77.619c-13.965,4.936,1.154,23-14.116,31.139S4.643,121.019,3.743,117.07c-.064-.263-.884-2.882-1.752-6.712-.2-.884-.4-1.839-.6-2.842-.048-.279-.1-.565-.159-.852A77.3,77.3,0,0,1,.081,97.42v-.287c-.072-1.234-.1-2.476-.072-3.71S.1,91.035.224,89.9C.678,85.5,1.936,81.449,4.507,78.543a12.158,12.158,0,0,1,2.229-2c10.613-7.381,14.849-3.8,14.769-14.705-.143-18.694,5.183-21.5,11.449-19.642S44.1,44.586,45.033,37.651,40.3-.056,54.523,0c24.682.08,12.189,31.545,9.7,36.624-5.971,12.237,6.449,14.156,9.4,23.089S67.565,72.683,53.608,77.619Z",
    transform: "translate(81.058 214.785)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M.185,127.166s-3.75-34.411,22.476-53.694C34.509,64.753,56.539,33.662,54.509,0",
    transform: "translate(81.877 231.553)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 2.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M.3.858c3.264-5.525,26.68,17.261,22.58,22.293S-2.794,6.16.3.858Z",
    transform: "translate(44.992 262.152)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M.006,2.178C.475-4.255,28.748,5,27.3,11.35S-.44,8.309.006,2.178Z",
    transform: "translate(39.381 291.906)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M24.666.475C29.674,4.393,4.944,25.69.542,20.969S19.889-3.275,24.666.475Z",
    transform: "translate(68.097 265.217)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    "data-name": "Path",
    d: "M23.629,1.109C27.832,5.886,3.963,17.828.38,12.438S19.616-3.422,23.629,1.109Z",
    transform: "translate(66.539 291.407)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    d: "M.036,3.071C-1.206-2.836,29.964.564,30.235,6.638S1.214,8.692.036,3.071Z",
    transform: "translate(41.23 314.142)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    "data-name": "Path",
    d: "M21.914,1.248C25.147,6.71,2.806,20.357.218,14.393S18.841-3.959,21.914,1.248Z",
    transform: "translate(66.732 309.086)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    "data-name": "Path",
    d: "M10.271.005C16.561.467,8.424,32.163,2.206,30.7S4.276-.456,10.271.005Z",
    transform: "translate(66.058 236.46)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    "data-name": "Path",
    d: "M.3.858c3.256-5.525,26.68,17.261,22.58,22.293S-2.774,6.12.3.858Z",
    transform: "translate(47.36 260.647)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    "data-name": "Path",
    d: "M.006,2.178C.475-4.255,28.748,5,27.3,11.35S-.44,8.309.006,2.178Z",
    transform: "translate(41.26 290.584)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-15",
    "data-name": "Path",
    d: "M24.667.472C29.675,4.4,4.954,25.687.543,20.966S19.9-3.262,24.667.472Z",
    transform: "translate(69.043 263.804)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-16",
    "data-name": "Path",
    d: "M0,11.495C.438,7.18,1.648,3.2,4.116.348,7.1-.249,9.61-.129,10.709,1.1,13.041,3.748,6.7,8.621,0,11.495Z",
    transform: "translate(81.783 291.96)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-17",
    "data-name": "Path",
    d: "M23.628,1.109C27.84,5.886,3.963,17.828.38,12.438S19.624-3.422,23.628,1.109Z",
    transform: "translate(67.717 290.396)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-18",
    "data-name": "Path",
    d: "M1.942,0S2.659,16.465.477,30.836,3.805,69.53,12.754,77.309",
    transform: "translate(68.002 259.658)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1.55
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-19",
    "data-name": "Path",
    d: "M.036,3.071C-1.206-2.837,29.964.563,30.235,6.646S1.214,8.7.036,3.071Z",
    transform: "translate(41.23 313.012)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-20",
    "data-name": "Path",
    d: "M1.258,13.244c-.04-.271-.1-.557-.151-.836A78.408,78.408,0,0,1,0,3.332V3.045C5.088.234,10.518-1.191,11.943,1.246,13.75,4.311,7.508,9.94,1.258,13.244Z",
    transform: "translate(81.664 307.52)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-21",
    "data-name": "Path",
    d: "M21.914,1.248C25.147,6.71,2.806,20.357.218,14.393S18.841-3.959,21.914,1.248Z",
    transform: "translate(70.546 305.185)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-22",
    "data-name": "Path",
    d: "M10.278,0C16.568.459,8.423,32.154,2.2,30.7S4.283-.433,10.278,0Z",
    transform: "translate(67.58 236.022)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-23",
    "data-name": "Path",
    d: "M41.47,55.35H22.1A17.436,17.436,0,0,1,4.814,40.223L.037,4.57A4.029,4.029,0,0,1,4.017,0H59.591a4.029,4.029,0,0,1,3.981,4.57L58.795,40.223A17.444,17.444,0,0,1,41.47,55.35Z",
    transform: "translate(41.787 332.771)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 251.027,
    height: 172.373,
    rx: 11.45,
    transform: "translate(64.299 25.836)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 236.744,
    height: 157.588,
    rx: 6.84,
    transform: "translate(71.441 33.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-24",
    "data-name": "Path",
    d: "M4.828,90.653A4.873,4.873,0,0,1,.051,85.08L11.532,0l9.5,1.075L9.6,86.457C9.262,88.854,4.828,90.653,4.828,90.653Z",
    transform: "translate(325.586 273.997)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-25",
    "data-name": "Path",
    d: "M0,7.3,4.244,15l9.419,6.1,3.957-.525L22.954,8.631,21.361,3.185,14.594,0,0,7.3Z",
    transform: "translate(327.221 331.354)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-26",
    "data-name": "Path",
    d: "M4.061,10.008C4.785,7.763,5.2,1.855,5.573,0,2.588.406,0,4.865,0,7.564.748,7.46,3.217,9.427,4.061,10.008Z",
    transform: "translate(375.844 84.777)",
    fill: "#d5a081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-27",
    "data-name": "Path",
    d: "M60.831.151c-7.962,1.354-30.8,5.3-36.76,12.739-4.586,5.732-7.962,22.54-16,42.269C5.743,49.3,2.781,38.67,1.3,33.1-.762,25.35-2.681,8.065,14.931,3.582,26.563.621,52.049-.422,60.831.151Z",
    transform: "translate(278.588 235.454)",
    fill: "#191337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-28",
    "data-name": "Path",
    d: "M41.72,0S22.1,1.982,13.232,12.811C6.274,21.306,0,47.189,0,47.189",
    transform: "translate(283.798 235.056)",
    fill: "none",
    stroke: "#f3f6fd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-29",
    "data-name": "Path",
    d: "M11.768,89.881,0,3.185,7.962,0,21.306,88.193c.541,3.137-1.863,3.71-4.244,4.14S12.325,93.081,11.768,89.881Z",
    transform: "translate(403.447 268.495)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-30",
    "data-name": "Path",
    d: "M10.064,98.861,0,0H9.825L19.841,98.129c.215,3.057-2.11,2.938-4.395,3.28C12.89,101.815,10.311,102.309,10.064,98.861Z",
    transform: "translate(374.411 269.904)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-31",
    "data-name": "Path",
    d: "M94.3,114.867c-2.078,15.358-24.682,17.516-50.955,18.368-.8.4-29.825.223-43.344-4.331l.47-104c0-8.758,3.758-23.28,16.568-23.487,21.5-.358,61.433-3.639,77.054,1.194,3.575,12.826,6.178,27.006.223,64.068C90.9,87.9,95.342,107.494,94.3,114.867Z",
    transform: "translate(326.632 143.557)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-32",
    "data-name": "Path",
    d: "M32.15,6.594c4.777,14.331,4.172,22.611-2.189,45.756C19.371,90.925,36.76,110.726,0,130.177c22.293-1.266,36.306-4.705,38.073-17.779,1-7.373-3.4-26.967,0-48.185,4.387-27.3,12.572-49.61,1.7-62.795C36.728-2.228,30.549,1.753,32.15,6.594Z",
    transform: "translate(382.858 146.025)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-33",
    "data-name": "Path",
    d: "M26.035,7.166A115.709,115.709,0,0,1,11.5,0S1.154,11.186,0,12.237c3.83,1.521,1.9,12.58,5.064,14.331s11.561-5.828,15.6-4.9C21.019,18.113,24.944,9.092,26.035,7.166Z",
    transform: "translate(256.736 343.487)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-34",
    "data-name": "Path",
    d: "M42.078,62.954l-16.72,8.081c-2.078-1.592-3.185-5.414-4.642-7.667-2.635-4.068-5.446-3.447-9.809-9.841L0,34.944,22.97,0,37.787,40.263c1.282,3.272.8,12.245.8,12.245C39.761,55.167,44.737,61.911,42.078,62.954Z",
    transform: "translate(301.871 269.729)",
    fill: "#191337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-35",
    "data-name": "Path",
    d: "M100.932,50.664c-5.621.947-22.946,3.256-28.36.844.565,5.366,1.139,14.881,1.139,14.881S27.4,61.962,10.016,68.594c0-.565,0-1.234.04-1.967.215-6.194,1.234-17.357,1.234-17.357S2.906,47.679.43,45.155A2.914,2.914,0,0,1,0,44.613c.382-3.185,4.22-16.521,11.29-27.444C17.253,7.957,25.732,3.77,41.043,1.6L61.361.187S81.529-1.947,90.82,8.212,100.932,50.664,100.932,50.664Z",
    transform: "translate(320.008 133.492)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-36",
    "data-name": "Path",
    d: "M21.815,4.108s0,9.753.844,16.72C6.632,28.049,3.209,33.782,3.416,34.96L0,20.924,6.712,20.2,10.955,0C13.432,2.5,21.815,4.108,21.815,4.108Z",
    transform: "translate(309.514 178.654)",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-37",
    "data-name": "Path",
    d: "M81.593,59.841H12.739L.12,5.573A4.538,4.538,0,0,1,4.538,0H68.9Z",
    transform: "translate(229.419 160.828)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-38",
    "data-name": "Path",
    d: "M138.653,2.46s8.471,22.532-18.455,31.99C102.786,40.6,70.071,39.3,70.071,39.3l-36.9,68.352a11.513,11.513,0,0,1-5.35,4.984l-1.019.47c-1.258,1.791-5.032,11.146-7.062,10.295L.405,114.347c-1.728-.709,2.58-6.967,3.408-8.639.581-1.17-.366-8.153.5-11.783,5.971-25.08,23.193-69.538,29.068-76.791,6-7.4,15.127-10.677,23.129-12.03A149.094,149.094,0,0,0,75.763,0Z",
    transform: "translate(263.528 231.696)",
    fill: "#1f1844"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-39",
    "data-name": "Path",
    d: "M7.381.725S4.5.366,0,.072",
    transform: "translate(323.463 232.349)",
    fill: "none",
    stroke: "#17ff44",
    strokeMiterlimit: 10,
    strokeWidth: 1.95
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-40",
    "data-name": "Path",
    d: "M42.12,73.979a10.661,10.661,0,0,1-11.6-5.812,16.043,16.043,0,0,1-.924-3.981l-.231-1.441-.215-1.33-.271-1.632a19.188,19.188,0,0,1-2.293.151c-6.011,0-15.836-2.389-20.127-11.489-3-6.369-1.393-12.811-1.895-16.72S2.089,25.269.767,20.994C-.921,15.524.353,8.2,2.877,6.169,14.238-3.035,37.67.787,37.67.787S45.632,3.08,44.835,19.17c.7-.621-.366,2.906.661,2.548a6.724,6.724,0,0,1,5.518.191c3.145,1.791,3.917,7.118-.629,15.231-.048.1-.1.191-.159.287a35.263,35.263,0,0,0,.35,4.5,5.493,5.493,0,0,0,.088.693c.366,2.755.836,6.322,1.3,9.769.669,4.976,1.433,9.236,1.7,10.892C54.326,67.371,50.576,72.61,42.12,73.979Z",
    transform: "translate(327.665 70.368)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-41",
    "data-name": "Path",
    d: "M43.734,19.17C44.53,3.08,36.568.787,36.568.787S13.137-3.035,1.775,6.169C-.008,7.6.08,10.683,0,13.334,4.411,8.693,14.658,8.955,22.611,8.119c3.806-.4,2.651,3.885,3.734,3.933,8.2-2.643,14.331.844,14.395,12.914l3.583-3.232C43.447,21.838,44.419,18.573,43.734,19.17Z",
    transform: "translate(328.782 70.4)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-42",
    "data-name": "Path",
    d: "M10.613,147H3.734C1.672,147,0,145.868,0,144.482V0H14.331V144.482C14.339,145.868,12.667,147,10.613,147Z",
    transform: "translate(444.801 231.879)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-43",
    "data-name": "Path",
    d: "M11.186,147H2.221C1,147,0,146.282,0,145.406V0H13.408V145.4C13.408,146.306,12.412,147,11.186,147Z",
    transform: "translate(199.299 231.879)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-44",
    "data-name": "Path",
    d: "M67.412,29.7,0,22.293V0L75.159,6.282,67.412,29.7Z",
    transform: "translate(332.396 198.376)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-45",
    "data-name": "Path",
    d: "M8.32,0H267.556a8.32,8.32,0,0,1,8.32,8.32v6.744H0V8.32A8.32,8.32,0,0,1,8.32,0Z",
    transform: "translate(191.21 220.541)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-46",
    "data-name": "Path",
    d: "M44.031,56.441l-.717,3.185H14.907L.074,2.826A2.253,2.253,0,0,1,2.256,0h0a2.261,2.261,0,0,1,2.2,1.728l9,37,3.344,14.037h0a1.163,1.163,0,0,0,0,.135v.048H41.237a2.858,2.858,0,0,1,2.795,3.5Z",
    transform: "translate(296.104 160.844)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.78,
    cy: 5.78,
    r: 5.78,
    transform: "translate(261.465 186.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-47",
    "data-name": "Path",
    d: "M1.887,10.908,0,0",
    transform: "translate(390.732 173.806)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-48",
    "data-name": "Path",
    d: "M0,8.957,1.68,0",
    transform: "translate(331.33 173.806)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-49",
    "data-name": "Path",
    d: "M55.359,25.111A38.237,38.237,0,0,0,54,15.262C51.991,6.5,46.123,2.865,36.943,1.217L28.185.2C27.389.1,12.707-.964,5.892,3.056,3.328,4.569-.039,8.232,0,10.684c.1,6.242,0,9.554,1.417,14.331,2.994-12.739,9.793,2.182,25.8-10.844,2.97-2.389,2.651,3.885,3.726,3.933,9.26-2.986,15.844,1.823,14.132,17.97,2.389-1.425,3.981-2.906,5.414-3.089C52.293,30.684,55.3,26.592,55.359,25.111Z",
    transform: "translate(326.401 58.719)",
    fill: "#1f1844"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-50",
    "data-name": "Path",
    d: "M24.092,5.478A34.936,34.936,0,0,1,2.779,25.605l-.215-1.33-.271-1.632A19.188,19.188,0,0,1,0,22.795C4.7,18.75,17.763,7.317,23.814,0c-.048.1-.1.191-.159.287a35.262,35.262,0,0,0,.35,4.5C24.037,4.968,24.061,5.2,24.092,5.478Z",
    transform: "translate(354.252 107.58)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-51",
    "data-name": "Path",
    d: "M39.689,4.108c.287-.326,1.178-1.131,1.178-1.131L40.183,0l-4.2,2.811a2.556,2.556,0,0,0-1.115,2.46l1.417,10.581C30.446,19.427,17.174,29.7,14.658,30.111c-3.185.533-4.252-3.447-5.971-2.524s-1.465,3.32-2.659,3.32c-.621,0-4.689-2.54-6.027-4.26,0,0,2.07,6.752,2.516,7.962,1.027,2.755,7.022,8.3,7.022,8.3a2.8,2.8,0,0,0,2.341.8L19.4,42.8l3.782-2.341C28.455,37.428,40.653,25.478,40.7,23.846,40.963,14.291,36.823,7.349,39.689,4.108Z",
    transform: "translate(333.4 89.952)",
    fill: "#1f1844"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-52",
    "data-name": "Path",
    d: "M0,1.849S1.7-1.336,3.487.654s0,6.067,0,6.067Z",
    transform: "translate(374.411 95.174)",
    fill: "#c68f6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-53",
    "data-name": "Path",
    d: "M106.8,0c-.072,6.823-.573,22.293-3.5,28.9-3.806,8.607-9.021,8.5-23.272,6.107S42.186,24.124,34.845,24.124A17.01,17.01,0,0,0,22.9,29.435H.036c-.207-1.178-.119-7.245,17.277-13.71,2.914-1.234,11.314-2.253,18.591-2.779C55.888,11.5,80.49,15.151,80.49,15.151s-.1-9.18-.661-14.546C85.18,3,101.868.748,106.8,0Z",
    transform: "translate(312.782 184.395)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-54",
    "data-name": "Path",
    d: "M0,.016s7.285-.6,7.285,5.494S0,11.672,0,11.672",
    transform: "translate(373.002 200.844)",
    fill: "none",
    stroke: "#d6d9e8",
    strokeMiterlimit: 10,
    strokeWidth: 5.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-55",
    "data-name": "Path",
    d: "M20.651,28.314H2.546L.006,2.558A2.389,2.389,0,0,1,2.49,0H19.855a2.389,2.389,0,0,1,2.492,2.484Z",
    transform: "translate(353.211 192.227)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-56",
    "data-name": "Path",
    d: "M0,3.846s1.123,7.166,13.463,6.5S29.554,0,29.554,0",
    transform: "translate(355.422 137.197)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-57",
    "data-name": "Path",
    d: "M14.3,9.618S6.741,7.954,3.85,8.99.228,12.174.013,14.475s2.221,5.573,11.6,9.045a284.235,284.235,0,0,0,29.315,8.7,54.364,54.364,0,0,0,12.739,1.29,5.8,5.8,0,0,0,5.215-4.419,15.5,15.5,0,0,1,.924-2.675c.8-1.592.494-3.471.955-4.777S62.314,11.29,59.8,9.985s-6.656,6.425-12.285,5.788-6.266-7.691-6.266-7.691,2.691-2.46,1.242-4.188S42.7.8,41.557.12s-5.183,1.728-5.183,1.728S23.349,7.2,18.253,9.356A15.772,15.772,0,0,1,14.3,9.618Z",
    transform: "translate(219.318 350.684)",
    fill: "#191337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-58",
    "data-name": "Path",
    d: "M0,0C16.72,9.554,36.162,9.753,36.162,9.753c5.43,1.266,10.868,4.881,17.842.732l.621-.334",
    transform: "translate(222.723 367.038)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-59",
    "data-name": "Path",
    d: "M9.691,9.873s9.658,2.906,11.545,6.043S29.572,9.475,26.73,4.053,27.765-.485,30.424,1.72s4.825.605,6.7,2.189,5.685,5.1,2.9,11.688-9.053,9.435-11.537,14.379-1.592,15.016-5.406,18.782S12.016,57.341,3.808,53.313,2.932,38.3,4.835,35.566s2.285-12.1,2.389-15.924S6.7,11.043,9.691,9.873Z",
    transform: "translate(318.334 332.109)",
    fill: "#191337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-60",
    "data-name": "Path",
    d: "M22.978,0s5.406,1.64,3.535,8.248-8.7,11.664-9.4,18.646-.637,13.185-7.4,18.248S0,49.5,0,49.5",
    transform: "translate(325.565 335.024)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.76
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManUsingLaptop);
export default __webpack_public_path__ + "static/media/Man_Using Laptop.754a804ec25b2336f785c0b4b834d5e8.svg";
export { ForwardRef as ReactComponent };